import { Buffer } from 'buffer';
import process from 'process';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import './assets/css/react-date-range-overrides.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './assets/fonts/JosefinSans-Bold.ttf';
import './assets/fonts/JosefinSans-Regular.ttf';

import { Amplify } from 'aws-amplify';

const cognitoDomain =
  process.env.REACT_APP_COGNITO_DOMAIN || 'auth.amplifyloyalty.com';

/** CRA inlines process.env at build time; read once and guard before .split (comma values can break inlining). */
function parseRedirectUrls(raw) {
  if (typeof raw === 'string' && raw.trim().length > 0) {
    return raw.split(',').map((u) => u.trim()).filter(Boolean);
  }
  return [];
}

const STATIC_REDIRECT_SIGN_IN = [
  'https://amplifyloyalty.com/login',
  'https://amplifyloyalty.com/sign-up',
  'https://www.amplifyloyalty.com/login',
  'https://www.amplifyloyalty.com/sign-up',
  'https://localhost:6128/login',
  'http://localhost:6128/login',
  'https://localhost:6128/sign-up',
  'http://localhost:6128/sign-up',
  'http://localhost:3000/login'
];

const STATIC_REDIRECT_SIGN_OUT = [
  'https://amplifyloyalty.com/login',
  'https://www.amplifyloyalty.com/login',
  'https://localhost:6128/login',
  'http://localhost:6128/login',
  'http://localhost:3000/login'
];

/**
 * Merge build-time allowlist with the current origin so www vs apex both work.
 * Cognito must still list every URL we might send (see configure-cognito-oauth-callbacks.js).
 */
function mergeRedirectUrls(envRaw, staticFallback, runtimePaths) {
  const fromEnv = parseRedirectUrls(envRaw);
  const base = fromEnv.length ? fromEnv : staticFallback;
  if (typeof window === 'undefined') return [...new Set(base)];
  const runtime = runtimePaths.map((p) => window.location.origin + p);
  return [...new Set([...base, ...runtime])];
}

const redirectSignIn = mergeRedirectUrls(
  process.env.REACT_APP_OAUTH_REDIRECT_SIGN_IN,
  STATIC_REDIRECT_SIGN_IN,
  ['/login', '/sign-up']
);

const redirectSignOut = mergeRedirectUrls(
  process.env.REACT_APP_OAUTH_REDIRECT_SIGN_OUT,
  STATIC_REDIRECT_SIGN_OUT,
  ['/login']
);

// Do not spread aws-exports here: any top-level `aws_*` key forces the legacy
// parser, which ignores Auth.Cognito.loginWith.oauth and breaks signInWithRedirect.
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_NKxruUwvS',
      userPoolClientId: '3e39k957m5mnj1fpp0um03l1c2',
      loginWith: {
        email: true,
        oauth: {
          domain: cognitoDomain,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn,
          redirectSignOut,
          responseType: 'code',
          providers: ['Google']
        }
      }
    }
  }
});

window.Buffer = Buffer;
window.process = process;

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <Router future={{ v7_relativeSplatPath: true }}>
    <App />
  </Router>
);

reportWebVitals();
